import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80c137ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "memberregistration" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center" }, "Nye medlemmer", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "row justify--end" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center mb-2" }, "Sprog / Language", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Dansk")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("English")
const _hoisted_13 = { class: "row justify--center mt-4 mb-4" }
const _hoisted_14 = { id: "newDanishMemberDanish" }
const _hoisted_15 = { class: "form" }
const _hoisted_16 = { class: "formdescription increasedfontsize" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Som betalende medlem af Dansk Dart Union,")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" får du en spillerlicens der giver det dig ret til at deltage alle officielle stævner. Licensen udløber den 31. december, og skal fornyes en gang årligt. Inden der er gået et år, så skal du sørge for at blive meldt ind i en dartklub. Se evt ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("vores klubliste")
const _hoisted_21 = { class: "formdescription increasedfontsize" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("As a paying member of the Danish Dart Union, you get a player licens, that gives you the right to participate in all offical competitions and events. The licens expires at the 31st of december, and have to be renewed once a year. Within a year of getting the licens you must become a member of a sanctioned dart club. ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("See here")
const _hoisted_24 = { class: "layout gutter--xl" }
const _hoisted_25 = { class: "row justify--space-around align--center" }
const _hoisted_26 = { class: "flex md6" }
const _hoisted_27 = { class: "flex md6" }
const _hoisted_28 = { class: "flex md6" }
const _hoisted_29 = { class: "flex md6 center" }
const _hoisted_30 = { class: "flex md6" }
const _hoisted_31 = { class: "flex md6" }
const _hoisted_32 = { class: "flex md4" }
const _hoisted_33 = { class: "flex md4" }
const _hoisted_34 = { class: "flex md6" }
const _hoisted_35 = { class: "flex md3" }
const _hoisted_36 = { class: "flex md3" }
const _hoisted_37 = { class: "flex md6" }
const _hoisted_38 = { class: "flex md6" }
const _hoisted_39 = { class: "row justify--center" }
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = { id: "newForeignPlayer" }
const _hoisted_42 = { class: "form" }
const _hoisted_43 = { class: "formdescription increasedfontsize" }
const _hoisted_44 = { class: "formdescription increasedfontsize" }
const _hoisted_45 = { class: "layout gutter--xl" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "flex md4" }
const _hoisted_48 = { class: "flex md4" }
const _hoisted_49 = { class: "flex md4" }
const _hoisted_50 = { class: "row align--center" }
const _hoisted_51 = { class: "flex md3" }
const _hoisted_52 = { class: "flex md3" }
const _hoisted_53 = { class: "flex md3" }
const _hoisted_54 = { class: "flex md3" }
const _hoisted_55 = { class: "row justify--center" }
const _hoisted_56 = { class: "flex" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "registermessage" }
const _hoisted_59 = { class: "formdescription increasedfontsize center" }
const _hoisted_60 = { class: "formdescription center" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Du kan nu tilmdelde dig stævner, men for disse er endelig gyldige skal licensen betales.", -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = { class: "formdescription increasedfontsize center" }
const _hoisted_64 = { class: "formdescription center" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "You can now sign-up to competitions, but for those to be final valid the license feed must be paid", -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { class: "layout gutter--xl" }
const _hoisted_68 = { class: "row justify--center" }
const _hoisted_69 = { class: "flex" }
const _hoisted_70 = { class: "flex" }
const _hoisted_71 = { class: "flex" }
const _hoisted_72 = { class: "registermessage" }
const _hoisted_73 = { class: "formdescription increasedfontsize center" }
const _hoisted_74 = { class: "formdescription increasedfontsize center" }
const _hoisted_75 = { class: "layout gutter--xl" }
const _hoisted_76 = { class: "row justify--center" }
const _hoisted_77 = { class: "flex" }
const _hoisted_78 = { class: "flex" }
const _hoisted_79 = { class: "sidebar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftSideBar = _resolveComponent("LeftSideBar")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_front_sidebar = _resolveComponent("front-sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LeftSideBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!_ctx.submitted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_va_button_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_button, {
                              size: "small",
                              color: (_ctx.languageValue === 1 ? '#ab0033' : 'primary'),
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.languageValue = 1))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            }, 8, ["color"]),
                            _createVNode(_component_va_button, {
                              size: "small",
                              color: (_ctx.languageValue === 2 ? '#ab0033' : 'primary'),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.languageValue = 2))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_va_button_group, { size: "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            size: "small",
                            color: (_ctx.nationalityValue === 1 ? 'success' : 'primary'),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nationalityValue = 1))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.languageValue === 2 ? 'Danish Player' : 'Dansk spiller'), 1)
                            ]),
                            _: 1
                          }, 8, ["color"]),
                          _createVNode(_component_va_button, {
                            size: "small",
                            color: (_ctx.nationalityValue === 2 ? 'success' : 'primary'),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.nationalityValue = 2))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.languageValue === 2 ? 'Foreign Player' : 'Udenlandsk spiller'), 1)
                            ]),
                            _: 1
                          }, 8, ["color"])
                        ]),
                        _: 1
                      })
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("p", _hoisted_16, [
                          _hoisted_17,
                          _hoisted_18,
                          _hoisted_19,
                          _createVNode(_component_router_link, { to: "/klubber/" }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" for at finde en klub i nærheden af dig. En spillerlicens koster " + _toDisplayString(_ctx.seniorLicenseProduct.produkt_pris + ' kr. for en voksenlicens og ' + _ctx.juniorLicenseProduct.produkt_pris + ' kr. for en junior-licens') + ", hvis mere end halvdelen af sæsonen er gået (efter d. 01/07) koster det kun halv pris (som automatisk bliver fratrukket ved kassen).", 1)
                        ], 512), [
                          [_vShow, _ctx.languageValue === 1]
                        ]),
                        _withDirectives(_createElementVNode("p", _hoisted_21, [
                          _hoisted_22,
                          _createVNode(_component_router_link, { to: "/klubber/" }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" for a list of clubs, to find a club near you. A player licens costs " + _toDisplayString(_ctx.seniorLicenseProduct.produkt_pris + ' Dkk. for an adult license ' + _ctx.juniorLicenseProduct.produkt_pris + ' Dkk. for a junior license') + ", if the season is more than halfway through (the 1st of July), a license is only at half the price (which automatically gets deducted at checkout).", 1)
                        ], 512), [
                          [_vShow, _ctx.languageValue === 2]
                        ]),
                        _createVNode(_component_va_form, {
                          ref: "form",
                          tag: "form"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    modelValue: _ctx.memberData.memberFirstName,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.memberData.memberFirstName) = $event)),
                                    type: "text",
                                    label: (_ctx.languageValue === 1 ? 'Fornavn' : 'First Name'),
                                    rules: [(memberFirstName) => _ctx.memberData.memberFirstName.length > 1 || (_ctx.languageValue === 1 ? 'Der mangler er fornavn' : 'The First Name is missing')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    modelValue: _ctx.memberData.memberLastName,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.memberData.memberLastName) = $event)),
                                    type: "text",
                                    label: (_ctx.languageValue === 1 ? 'Efternavn' : 'Last Name'),
                                    rules: [(memberLastName) => _ctx.memberData.memberLastName.length > 1 || (_ctx.languageValue === 1 ? 'Der mangler et efternavn' : 'The Last Name is missing')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    modelValue: _ctx.memberData.memberUserName,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.memberData.memberUserName) = $event)),
                                    type: "text",
                                    label: (_ctx.languageValue === 1 ? 'Vælg et unikt brugernavn': 'Choose a unique Username'),
                                    placeholder: (_ctx.languageValue === 1 ? 'Brugernavn' : 'Username'),
                                    rules: [(memberUserName) => _ctx.memberData.memberUserName.length > 1 || (_ctx.languageValue === 1 ? 'Brugernavnet mangler' : 'Username is missing')],
                                    success: _ctx.userNameAvailable === true,
                                    error: _ctx.userNameAvailable === false
                                  }, null, 8, ["modelValue", "label", "placeholder", "rules", "success", "error"])
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createVNode(_component_va_button, {
                                    rounded: false,
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkUserName()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Check brugernavnet status' : 'Check Username availability'), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _createVNode(_component_va_input, {
                                    autocomplete: "on",
                                    bordered: "",
                                    modelValue: _ctx.memberData.memberPassword,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.memberData.memberPassword) = $event)),
                                    type: "password",
                                    label: (_ctx.languageValue === 1 ? 'Vælg en adgangskode' : 'Choose a password'),
                                    rules: [(memberPassword) => _ctx.passwordTest(_ctx.memberData.memberPassword) || (_ctx.languageValue === 1 ? 'Adgangskoden skal være på minimum 8 tegn, indeholde tal, specialtegn, store og små bogstaver' : 'The password must be minimum 8 character, contain numbers, special characters, uppercase and lowercase letters')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _createVNode(_component_va_input, {
                                    autocomplete: "on",
                                    bordered: "",
                                    modelValue: _ctx.repeatPassword,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.repeatPassword) = $event)),
                                    type: "password",
                                    label: (_ctx.languageValue === 1 ? 'Gentag adgangskoden' : 'Repeat the password'),
                                    rules: [value => value === _ctx.memberData.memberPassword || (_ctx.languageValue === 1 ? 'Adgangskoderne er ikke ens' : 'The passwords does not match')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    modelValue: _ctx.memberData.memberBirthDate,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.memberData.memberBirthDate) = $event)),
                                    type: "date",
                                    label: (_ctx.languageValue === 1 ? 'Fødselsdag' : 'Birthdate'),
                                    rules: [(memberBirthDate) => _ctx.memberData.memberBirthDate !== '' || (_ctx.languageValue === 1 ? 'Fødselsdagen mangler' : 'Birthdate is missing')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _createVNode(_component_va_select, {
                                    bordered: "",
                                    modelValue: _ctx.memberGenderValue,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.memberGenderValue) = $event)),
                                    options: _ctx.memberGenderOptions,
                                    label: (_ctx.languageValue === 1 ? 'Køn' : 'Gender'),
                                    "text-by": (_ctx.languageValue === 1 ? (memberGenderOptions) => memberGenderOptions.danish : (memberGenderOptions) => memberGenderOptions.english),
                                    "track-by": (memberGenderOptions) => memberGenderOptions.id,
                                    rules: [v => v.id !== 0 || (_ctx.languageValue === 1 ? 'Vælg venligst køn' : 'Please choose a gender')]
                                  }, null, 8, ["modelValue", "options", "label", "text-by", "track-by", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    modelValue: _ctx.memberData.memberAddress,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.memberData.memberAddress) = $event)),
                                    type: "text",
                                    label: (_ctx.languageValue === 1 ? 'Adresse' : 'Address'),
                                    rules: [(memberAddress) => _ctx.memberData.memberAddress.length > 1 || (_ctx.languageValue === 1 ? 'Der mangler en adresse' : 'Please provide a address')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    modelValue: _ctx.memberData.memberZipCode,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.memberData.memberZipCode) = $event)),
                                    type: "number",
                                    onFocus: _cache[14] || (_cache[14] = ($event: any) => (_ctx.cityZipCodeInputFocus = 2)),
                                    label: (_ctx.languageValue === 1 ? 'Postnummer' : 'Zip Code'),
                                    rules: [(memberZipCode) => _ctx.memberData.memberZipCode.length === 4 || (_ctx.languageValue === 1 ? 'Der manger et postnummer' : 'The zip code i missing')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    modelValue: _ctx.memberData.memberCity,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.memberData.memberCity) = $event)),
                                    onFocus: _cache[16] || (_cache[16] = ($event: any) => (_ctx.cityZipCodeInputFocus = 1)),
                                    type: "text",
                                    label: (_ctx.languageValue === 1 ? 'By' : 'City'),
                                    rules: [(memberCity) => _ctx.memberData.memberCity.length > 1 || (_ctx.languageValue === 1 ? 'Vær venlig at angive en by' : 'Please provide a city')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    modelValue: _ctx.memberData.memberTelephone,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.memberData.memberTelephone) = $event)),
                                    type: "number",
                                    label: (_ctx.languageValue === 1 ? 'Telefonnummer' : 'Telephone number'),
                                    rules: [(memberTelephone) => _ctx.memberData.memberTelephone === null || _ctx.memberData.memberTelephone.length > 5 || (_ctx.languageValue === 1 ? 'Vær venlig at angive et telefonnummer' : 'Please provide a telephone number')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    modelValue: _ctx.memberData.memberEmail,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.memberData.memberEmail) = $event)),
                                    type: "email",
                                    label: "Email",
                                    rules: [(memberEmail) => _ctx.testLegalEmail(_ctx.memberData.memberEmail) || (_ctx.languageValue === 1 ? 'Vær venlig at angive en email adresse' : 'Please provide an email address')]
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 512),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_va_button, {
                              class: "btn",
                              color: "success",
                              size: "large",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.$refs.form.validate();_ctx.createMember()})
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString((this.languageValue === 1 ? 'Køb licens' : 'Buy License')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ], 512), [
                      [_vShow, _ctx.nationalityValue === 1]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _withDirectives(_createElementVNode("p", _hoisted_43, "Hvis du, som udenlandskspiller ønsker at stille op ved et dansk stævne, behøver du blot at registrerer dig. Det er gratis og giver dig ret til at stille op til alle internationale stævner", 512), [
                          [_vShow, _ctx.languageValue === 1]
                        ]),
                        _withDirectives(_createElementVNode("p", _hoisted_44, "As a foreign player, if you want to participate in a event in Denmark, you only need to register yourself here, and then sign up as normal. The registration is free.", 512), [
                          [_vShow, _ctx.languageValue === 2]
                        ]),
                        _createVNode(_component_va_form, { ref: "form" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    type: "text",
                                    modelValue: _ctx.foreignPlayerData.foreignPlayerFirstName,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerFirstName) = $event)),
                                    label: (_ctx.languageValue === 1 ? 'Fornavn' : 'First Name'),
                                    rules: [(foreignPlayerFirstName) => _ctx.foreignPlayerData.foreignPlayerFirstName.length > 1 || (_ctx.languageValue === 1 ? 'Vær venlig at angive et fornavn' : 'Please provide a first name')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    type: "text",
                                    modelValue: _ctx.foreignPlayerData.foreignPlayerLastName,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerLastName) = $event)),
                                    label: (_ctx.languageValue === 1 ? 'Efternavn' : 'Last Name'),
                                    rules: [(foreignPlayerLastName) => _ctx.foreignPlayerData.foreignPlayerLastName.length > 1 || (_ctx.languageValue === 1 ? 'Vær venlig at angive et efternavn' : 'Please provide a last name')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                  _createVNode(_component_va_input, {
                                    bordered: "",
                                    type: "text",
                                    modelValue: _ctx.foreignPlayerData.foreignPlayerEmail,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerEmail) = $event)),
                                    label: "Email",
                                    rules: [(foreignPlayerEmail) => _ctx.testLegalEmail(_ctx.foreignPlayerData.foreignPlayerEmail) || (_ctx.languageValue === 1 ? 'Vær venlig at angive en email adresse' : 'Please provide an email adress')]
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _createVNode(_component_va_select, {
                                    bordered: "",
                                    searchable: "",
                                    modelValue: _ctx.countryStringValue,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.countryStringValue) = $event)),
                                    label: (_ctx.languageValue === 1 ? 'Nationalitet' : 'Nationality'),
                                    options: _ctx.countryListOptions,
                                    rules: [(countryStringValue) => countryStringValue !== '' || (_ctx.languageValue === 1 ? 'Angiv venligst nationalitet' : 'Please provide a nationality')]
                                  }, null, 8, ["modelValue", "label", "options", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _createVNode(_component_va_input, {
                                    class: "center",
                                    bordered: "",
                                    type: "date",
                                    modelValue: _ctx.foreignPlayerData.foreignPlayerBirthDate,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerBirthDate) = $event)),
                                    label: (_ctx.languageValue === 1 ? 'Fødselsdag' : 'Birthdate'),
                                    rules: [(foreignPlayerBirthDate) => _ctx.foreignPlayerData.foreignPlayerBirthDate !== '' || (_ctx.languageValue === 1 ? 'Fødselsdagen mangler' : 'Birthdate is missing')]
                                  }, null, 8, ["modelValue", "label", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                  _createVNode(_component_va_select, {
                                    bordered: "",
                                    modelValue: _ctx.foreignPlayerGenderValue,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.foreignPlayerGenderValue) = $event)),
                                    options: _ctx.foreignPlayerGenderOptions,
                                    label: (_ctx.languageValue === 1 ? 'Køn' : 'Gender'),
                                    "text-by": (_ctx.languageValue === 1 ? (foreignPlayerGenderOptions) => foreignPlayerGenderOptions.danish : (foreignPlayerGenderOptions) => foreignPlayerGenderOptions.english),
                                    "track-by": (foreignPlayerGenderOptions) => foreignPlayerGenderOptions.id,
                                    rules: [v => v.id !== 0 || (_ctx.languageValue === 1 ? 'Vælg venligst køn' : 'Please choose a gender')]
                                  }, null, 8, ["modelValue", "options", "label", "text-by", "track-by", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                  _createVNode(_component_va_checkbox, {
                                    bordered: "",
                                    modelValue: _ctx.foreignPlayerData.foreignPlayerParadart,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerParadart) = $event)),
                                    label: (_ctx.languageValue === 1 ? 'Paradartspiller' : 'Paradart player')
                                  }, null, 8, ["modelValue", "label"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 512),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createVNode(_component_va_button, {
                              class: "btn",
                              color: "success",
                              size: "large",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => {_ctx.$refs.form.validate();_ctx.createForeignPlayer()})
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString((this.languageValue === 1 ? 'Opret spiller' : 'Register Player')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ], 512), [
                      [_vShow, _ctx.nationalityValue === 2]
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _withDirectives(_createElementVNode("div", _hoisted_58, [
                      _withDirectives(_createElementVNode("p", _hoisted_59, "Tillykke du er klar til at blive oprettet, og en licens er blevet lagt i kurven. Du kan nu vælge", 512), [
                        [_vShow, _ctx.languageValue === 1]
                      ]),
                      _withDirectives(_createElementVNode("p", _hoisted_60, _hoisted_62, 512), [
                        [_vShow, _ctx.languageValue === 1]
                      ]),
                      _withDirectives(_createElementVNode("p", _hoisted_63, "Congrautualtion you are now ready to be registered, and a license is in the cart. You kan now choose", 512), [
                        [_vShow, _ctx.languageValue === 2]
                      ]),
                      _withDirectives(_createElementVNode("p", _hoisted_64, _hoisted_66, 512), [
                        [_vShow, _ctx.languageValue === 2]
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            (_ctx.webHistory.state.back.includes('/staevner'))
                              ? (_openBlock(), _createBlock(_component_va_button, {
                                  key: 0,
                                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.$router.push(_ctx.webHistory.state.back)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((this.languageValue === 1 ? 'Tilbage stævnet' : 'Back to the competition')), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_va_button, {
                                  key: 1,
                                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$router.push('/')))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((this.languageValue === 1 ? 'Tilbage til forsiden': 'Back to the frontpage')), 1)
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _createVNode(_component_va_button, {
                              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.clearInput()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString((this.languageValue === 1 ? 'Køb flere licenser?' : 'Purchase additonal licenses?')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createVNode(_component_va_button, {
                              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.$router.push('/kurven')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString((this.languageValue === 1 ? 'Til kassen' : 'Checkout')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ], 512), [
                      [_vShow, _ctx.nationalityValue === 1]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_72, [
                      _withDirectives(_createElementVNode("p", _hoisted_73, "Tillykke du er blevet oprettet som en udenlandsk spiller. Du kan nu vælge", 512), [
                        [_vShow, _ctx.languageValue === 1]
                      ]),
                      _withDirectives(_createElementVNode("p", _hoisted_74, "Congratulation, you have been registered as a foreign player. You can now choose", 512), [
                        [_vShow, _ctx.languageValue === 2]
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("div", _hoisted_77, [
                            (_ctx.webHistory.state.back.includes('/staevner'))
                              ? (_openBlock(), _createBlock(_component_va_button, {
                                  key: 0,
                                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$router.push(_ctx.webHistory.state.back)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((this.languageValue === 1 ? 'Tilbage til stævnet' : 'Back to the Competition')), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_va_button, {
                                  key: 1,
                                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.$router.push('/')))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((this.languageValue === 1 ? 'Tilbage til forside' : 'Back to the frontpage')), 1)
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _createElementVNode("div", _hoisted_78, [
                            _createVNode(_component_va_button, {
                              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.clearInput()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString((this.languageValue === 1 ? 'Opret endnu en spiller' : 'Register additional players')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ], 512), [
                      [_vShow, _ctx.nationalityValue === 2]
                    ])
                  ]))
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_79, [
      _createVNode(_component_front_sidebar)
    ])
  ]))
}